import { useState } from "react";
import { nFormatter } from "../../utils/parseNumber";
import { Link } from "react-router-dom";
import { INiche } from "services/types";
import { FollowButton, UnFollowButton } from "../buttons/FollowUnfollowButtons";
import { Image } from "components";
import ProfileDropdownMenu from "components/profile/ProfileDropdownMenu";
import ProfileMenuPopup from "components/profile/ProfileMenuPopup";
import { BackButton } from "../buttons";
import { routes } from "routes";

import "./NicheInfo.scss";

interface IProps {
  niche: INiche;
  following: boolean | undefined;
  follow: () => void;
  unfollow: () => void;
}

export const NicheInfo = (props: IProps) => {
  const { niche } = props;
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  const handleMenu = () => {
    setIsOpenMenu((prev) => !prev);
  };

  return (
    <div className="nicheInfo">
      <div className="nicheInfoWrap">
        <h2>{niche.name}</h2>

        <div className="counters">
          <span className="followers count" title={new Intl.NumberFormat().format(niche.subscribers)}>
            {nFormatter(niche.subscribers, 1)}
            <p className="label">Followers</p>
          </span>

          <Image className="picture" src={niche.thumbnail} />

          <span className="posts count" title={new Intl.NumberFormat().format(niche.gifs)}>
            {nFormatter(niche.gifs, 1)}
            <p className="label">Posts</p>
          </span>
        </div>

        {props.following && <UnFollowButton
          className="follow"
          variant="outlined"
          fullWidth
          onClick={props.unfollow}
        >
          Unfollow
        </UnFollowButton>}

        {!props.following && <FollowButton
          className="follow"
          variant="outlined"
          fullWidth
          onClick={props.follow}
        >
          Follow
        </FollowButton>}

        <div className="mod">
          <span>Mod: </span><Link to="/users/phpunit">RedGIFs Team</Link>
        </div>

        {props.niche.description && (
          <div className="description">{props.niche.description}</div>
        )}
      </div>

      <BackButton
        link={routes.niches()}
      />

      <div className="niche-menu">
        <ProfileDropdownMenu
          tooglePopup={handleMenu}
          nicheName={niche.id}
        />
        <ProfileMenuPopup
          isOpen={isOpenMenu}
          togglePopup={handleMenu}
          nicheName={niche.id}
        />
      </div>

    </div>
  );
};
